import { AxiosRequestConfig } from 'axios'
import { IPaginate, Repository } from 'ecp/repositories/Repository'
import { IPartnerDetail, IPartnerLog, PartnerUpdateBody } from 'egi/app/Settings/views/PartnerApiCredentials/partnerApiCredentials'

import api from 'services/api'

class PartnerApiRepository extends Repository<{}> {
  async detail (promoterId: string, config?: AxiosRequestConfig) {
    return Repository.handle<{ promoter: IPartnerDetail }>(() =>
      this.api.get(`${this.path}/promoters/${promoterId}`, config)
    )
  }

  async update (promoterId: string, data: PartnerUpdateBody, config?: AxiosRequestConfig) {
    return Repository.handle(() =>
      this.api.patch(`${this.path}/promoters/${promoterId}`, data, config)
    )
  }

  async generateToken (promoterId: string, config?: AxiosRequestConfig) {
    return Repository.handle<{ token: string }>(() =>
      this.api.post(`${this.path}/promoters/${promoterId}/token`, {}, config)
    )
  }

  async logs (promoterId: string, config?: AxiosRequestConfig) {
    return Repository.handle<{ logs: IPaginate<IPartnerLog>[string] }>(() =>
      this.api.get(`${this.path}/promoters/${promoterId}/logs`, config)
    )
  }
}

export default new PartnerApiRepository({ api, path: '/partner-api' })
